import { useState, useEffect } from 'react';

export default function useWindowResizeListener() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    // Function to update window size
    const updateWindowSize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    // Add event listener
    window.addEventListener('resize', updateWindowSize);

    // Clean-up function
    return () => {
      window.removeEventListener('resize', updateWindowSize);
    };
  }, []); // Empty array ensures effect is only run on mount and unmount

  return windowSize;
};
